import {
    AllEvents,
    AppState,
    Block,
    EntitledToView,
    PublicationType,
    RequiredAccess,
    TogglesReduxState,
} from '@news-mono/web-common'
import { GetOffersResult } from '@west-australian-newspapers/subscription-offer-types'
import { Logger } from '@west-australian-newspapers/typescript-log'
import H from 'history'
import React from 'react'
import { connect, DispatchProp } from 'react-redux'
import {
    responsiveComponent,
    ResponsiveProps,
} from '../../__helpers/responsive-component'
import {
    InlinePositionedContent,
    TargetedContent,
} from '../../templates/Publication/Publication.props'
import { LazyBreachWallContentWrapper } from './components/BreachWallContentWrapper/BreachWallContentWrapper.lazy'
import { createIsEntitledChangeHandler } from './createIsEntitledChangeHandler'

interface OwnProps {
    requiredAccess: RequiredAccess
    location: H.Location
    blocks: Block[]
    slug: string
    topicIds: string[]
    // inlinePositionedContent and targetedContent are for placing ads between content
    inlinePositionedContent?: InlinePositionedContent[]
    targetedContent?: TargetedContent
    onEvent: (event: AllEvents) => void
    children: (content: {
        blocks: Block[]
        inlinePositionedContent: InlinePositionedContent[] | undefined
        targetedContent: TargetedContent | undefined
    }) => React.ReactElement<any>
    publication: PublicationType
    log: Logger
    subscriptionOffers?: GetOffersResult
}

export type InternalArticleBreachProps = OwnProps & {
    toggles: TogglesReduxState
} & DispatchProp<any> &
    ResponsiveProps
const mapStateToProps = (state: AppState) => ({ toggles: state.toggles })

export const InternalArticleBreach: React.FC<InternalArticleBreachProps> = (
    props,
) => {
    const {
        blocks,
        inlinePositionedContent,
        targetedContent,
        requiredAccess,
        location,
        onEvent,
        slug,
        publication,
        log,
        topicIds,
    } = props

    return (
        <EntitledToView
            requiredAccess={requiredAccess}
            articleSlug={slug}
            topicIds={topicIds}
            onIsEntitledChange={createIsEntitledChangeHandler(
                location,
                onEvent,
                publication,
            )}
            entitled={() => {
                return props.children({
                    blocks,
                    inlinePositionedContent,
                    targetedContent,
                })
            }}
            notEntitled={() => {
                return (
                    <LazyBreachWallContentWrapper
                        publication={publication}
                        requiredAccess={requiredAccess.level}
                        location={location}
                        log={log}
                        onEvent={onEvent}
                        initialOfferData={props.subscriptionOffers}
                    />
                )
            }}
        />
    )
}

export const ArticleBreach: React.ComponentType<OwnProps> =
    responsiveComponent<OwnProps>(
        connect<{ toggles: TogglesReduxState }, {}, OwnProps, AppState>(
            mapStateToProps,
            null,
            null,
            {},
        )(InternalArticleBreach),
    )

ArticleBreach.displayName = 'ArticleBreach'
